// extracted by mini-css-extract-plugin
module.exports = {"gradeResultContent":"section_gradeResultContent__3wEXP","gradeHeader":"section_gradeHeader__O7f_2"};